module.exports = __webpack_public_path__ + "media/images/city_img/n-1679f5c93dbbf32d6d84a79f0529c74a.jpg";